export default {"src":"/_next/static/media/lol.81ae143b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};